__webpack_require__.p = "/prj--04-interactive-news-globe/";